"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTradeUrl = exports.getTxUrl = exports.getTokenUrl = exports.getAddressUrl = void 0;
var EXPLORER_URLS = {
    BSC: 'https://bscscan.com/',
    BSC_TEST: 'https://testnet.bscscan.com/',
    ETH: 'https://etherscan.com/',
    ETH_ROPSTEN: 'https://ropsten.etherscan.com/',
    POLY: 'https://polygonscan.com/',
    SOL: 'https://solscan.io/',
    AVAX: 'https://snowtrace.io/',
    TERRA: 'https://finder.terra.money/',
    FTM: 'https://ftmscan.com/',
    ARB: 'https://arbiscan.io/',
    SUI: 'https://suiexplorer.com/',
    BASE: 'https://basescan.org/',
    ZKSYNC: 'https://explorer.zksync.io/',
};
var DEX_URLS = {
    // On BSC
    CAKE: 'https://pancakeswap.finance/swap?outputCurrency=',
    APE: 'https://app.apeswap.finance/swap?inputCurrency=BNB&outputCurrency=',
    UNISWAP: 'https://app.uniswap.org/#/swap?outputCurrency=',
    // On Poly
    QUICK: 'https://quickswap.exchange/#/swap?outputCurrency=',
    // On Solana
    RAYDIUM: 'https://raydium.io/swap/?inputCurrency=sol&outputCurrency=',
    // Avax
    PANGOLIN: 'https://app.pangolin.exchange/#/swap?outputCurrency=',
};
var getBaseUrl = function (chain) {
    var baseUrl = EXPLORER_URLS[chain];
    if (!baseUrl) {
        throw new Error("No explorer URL for chain: ".concat(chain));
    }
    return baseUrl;
};
var getAddressUrl = function (address, chain) {
    if (chain === void 0) { chain = 'BSC'; }
    return "".concat(getBaseUrl(chain), "address/").concat(address);
};
exports.getAddressUrl = getAddressUrl;
var getTokenUrl = function (address, chain) {
    if (chain === void 0) { chain = 'BSC'; }
    return "".concat(getBaseUrl(chain), "token/").concat(address);
};
exports.getTokenUrl = getTokenUrl;
var getTxUrl = function (txHash, chain) {
    if (chain === void 0) { chain = 'BSC'; }
    return "".concat(getBaseUrl(chain), "tx/").concat(txHash);
};
exports.getTxUrl = getTxUrl;
var getTradeUrl = function (address, dex) {
    return "".concat(DEX_URLS[dex]).concat(address);
};
exports.getTradeUrl = getTradeUrl;
